<template>
  <div v-if="!loading" class="noresult" style="display: none" :class="{ 'd-block': items.length == 0 }">
    <div class="text-center">
      <lottie class="avatar-xl" colors="primary:#121331,secondary:#08a88a" :options="defaultOptions" :height="75" :width="75" />

      <h5 class="mt-2">No Orders</h5>
      <p class="text-muted mb-3">Try to order something.</p>

    </div>
  </div>
</template>
  
<script>
import Lottie from "@/components/widgets/lottie.vue";
import animationData from "@/components/widgets/itykargr.json";

export default {
  name: "NoBillsOverlay",
  components: {
    Lottie,
  },
  props: {
    loading: Boolean,
    items: Array,
    getKeyword: String,
  },
  data() {
    return {
      defaultOptions: {
        animationData,
      },
    };
  },
};
</script>
  
<style scoped>
</style>
  